import config from 'config/config.json';

export const HOST = `${config.cdn_host}/static/files`;
